import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  const allCategories = [...new Set(comics.map((c) => ({ id: c.category, name: c.categoryName })))];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="latest-heading">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 id="latest-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500">每日新鲜韩漫，精彩不断更新</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.01]"
              data-product-shop=""
            >
              <div className="w-[90px] h-[126px] flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 最新韩漫`}
                  title={`${comic.title} - 韩漫在线免费阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between py-1">
                <div>
                  <h3 className="text-[14px] font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug mb-1.5">
                    {comic.title}
                  </h3>
                  <p className="text-[11px] text-foreground-500 line-clamp-1">{comic.description}</p>
                </div>
                <div>
                  <div className="flex items-center gap-1 text-[11px] text-foreground-400 mb-1">
                    <span>{comic.author}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] bg-primary-100 text-primary-600 px-2 py-0.5 rounded-full whitespace-nowrap font-medium">
                      更新至{comic.chapters}话
                    </span>
                    <span className="text-[10px] text-foreground-400">
                      {comic.updatedAt}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-sm text-foreground-500 font-medium whitespace-nowrap">热门标签：</span>
            {['甜宠', '重生', '逆袭', '复仇', '穿越', '校园', '都市', '职场', '奇幻', '热血', '治愈', '悬疑'].map((tag) => (
              <span
                key={tag}
                className="cursor-pointer px-3 py-1.5 text-xs bg-background-50 border border-background-200/70 rounded-full text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-colors duration-200 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}